import React from "react";
import PropTypes from "prop-types"
import 'react-phone-input-2/lib/style.css'
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";


class ShareableContactInformationView extends React.Component {

    static propTypes = {
        displayName: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
        phoneNumber: PropTypes.string.isRequired,
        about: PropTypes.string.isRequired,
        header: PropTypes.string.isRequired,
    };

    handleBackClicked = (event) => {
        EventPublisher.publish(UIInteractionEvents.BACK_CLICKED, {});
    };

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header border-bottom-box">
                                <span className="align-middle">
                                    {this.props.header}
                                </span>
                                <span className="ml-auto float-right">
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={this.handleBackClicked}
                                    >
                                        Back
                                    </button>
                                </span>
                            </div>
                            <div className="card-body">
                                <form>
                                    <div className="form-group row">
                                        <label htmlFor="staticName"
                                               className="col-sm-2 col-form-label">Name</label>
                                        <div className="col-sm-10">
                                            <div className="form-control">
                                                {this.props.displayName}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="staticEmail" className="col-sm-2 col-form-label">Email</label>
                                        <div className="col-sm-10">
                                            <div className="form-control" >
                                                <a href={"mailto:"+ this.props.email} target="_blank" rel="noreferrer" className="">{this.props.email}</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="staticPhoneNumber"
                                               className="col-sm-2 col-form-label">Phone Number</label>
                                        <div className="col-sm-10">
                                            <div className="form-control">
                                                {this.props.phoneNumber}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="staticAbout"
                                               className="col-sm-2 col-form-label">About</label>
                                        <div className="col-sm-10">
                                            <div className="">
                                                <textarea
                                                    className={"form-control"}
                                                    id="inputAbout"
                                                    rows="10"
                                                    disabled
                                                    value={this.props.about}/>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default ShareableContactInformationView;